import { render } from "./ModalNuevoEvento.vue?vue&type=template&id=eb094daa"
import script from "./ModalNuevoEvento.vue?vue&type=script&lang=js"
export * from "./ModalNuevoEvento.vue?vue&type=script&lang=js"

import "./ModalNuevoEvento.vue?vue&type=style&index=0&id=eb094daa&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__